module.exports = __webpack_public_path__ + "static/media/genetic-reports-slider-2x.d6b95b1a.jpg";